const TimeClose = () => (
  <>
    <path
      fill="currentColor"
      d="M12.5 11.792V7.5a.48.48 0 0 0-.144-.356.49.49 0 0 0-.357-.144.48.48 0 0 0-.356.144.49.49 0 0 0-.143.356v4.379q0 .152.056.297a.8.8 0 0 0 .186.274l.843.843a.5.5 0 0 0 .344.15.47.47 0 0 0 .364-.15.5.5 0 0 0 .16-.354.5.5 0 0 0-.16-.354z"
    />
    <path
      fill="currentColor"
      d="M19.5 12a7.5 7.5 0 1 0-7.5 7.5.5.5 0 0 1 0 1 8.5 8.5 0 1 1 8.5-8.5.5.5 0 0 1-1 0"
    />
    <path
      fill="currentColor"
      d="m16.793 17.5-1.768-1.768a.48.48 0 0 1-.15-.353q0-.204.15-.354t.354-.15.353.15l1.768 1.768 1.768-1.768q.15-.15.354-.15t.353.15.15.354-.15.353L18.207 17.5l1.768 1.768q.15.15.15.354t-.15.353-.354.15a.49.49 0 0 1-.353-.15L17.5 18.207l-1.768 1.768q-.15.15-.353.15a.49.49 0 0 1-.354-.15.48.48 0 0 1-.15-.354q0-.203.15-.353z"
    />
  </>
)
export default TimeClose
